(() => {
  const addFieldKeys = (root = document) => {
    root.querySelectorAll('.ttc-field-keys [data-ttc-field-key]').forEach((field) => {
      if (field.querySelector(':scope > .ttc-field-key-badge')) return;

      const badge = document.createElement('span');
      badge.className = 'ttc-field-key-badge';
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = field.dataset.ttcFieldKey;

      if (field.matches('details') && field.firstElementChild?.matches('summary')) {
        field.firstElementChild.insertAdjacentElement('afterend', badge);
      } else {
        field.insertAdjacentElement('afterbegin', badge);
      }
    });
  };

  if (!window.TtcFieldKeys) {
    window.TtcFieldKeys = { refresh: addFieldKeys };
    document.addEventListener('shopify:section:load', (event) => addFieldKeys(event.target));
  }

  addFieldKeys();
})();
